import React, {useContext, useEffect} from 'react'
import {AutoComplete, Form} from "antd";
import config from "../../../config";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const {Option} = AutoComplete

const PurchaseCurrency = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {purchaseItems} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems

    useEffect(() => {
        if (record.selectedCurrency) {
            form.setFieldsValue({
                currencyComplete: record.selectedCurrency
            })
        }
    }, [record.stock])

    const handleCurrencyChange = (val) => {
        const newList = replaceIndexAt(
            purchaseList,
            {
                ...purchaseList[rowIndex],
                selectedCurrency: val
            },
            rowIndex
        )
        setPurchaseList(newList)
    }


    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    name={'currencyComplete'}
                    style={{marginBottom: 0}}
                >
                    <AutoComplete
                        onChange={handleCurrencyChange}
                    >
                        {
                            config.currencyOptions.map(currency => <Option key={currency} value={currency}/>)
                        }
                    </AutoComplete>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseCurrency